<template>
  <section :class="{ 'section-builder-button-row': true }">
    <GeneralTheme :theme="configuration">
      <ButtonRow
        v-if="buttonRow"
        v-bind="buttonRow"
      >
      </ButtonRow>
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import ButtonRow from './ButtonRow.vue';
import type { SectionBuilderButtonRow } from '~/sanity/types';
defineProps<SectionBuilderButtonRow>();
</script>

<style></style>
